import React from 'react'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import PriceRowValueDiscount from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscount'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import CruiseLoyaltyPoints from 'components/Cruises/CruiseLoyaltyPoints'

export interface PriceRoomTypeProps {
  offer?: App.CruiseOffer;
  priceFrom: App.CruisePriceDetails;
  header?: boolean;
  hasValidDepartures?: boolean;
}

function CruisePriceRoomTypeInfo({ priceFrom, hasValidDepartures, offer, header = false }: PriceRoomTypeProps): React.ReactElement {
  return (
    <>
      <Group direction="vertical" gap={4}>
        {!!offer && <CruiseLoyaltyPoints offer={offer} calculationType="estimate" />}

        {hasValidDepartures && <div>
          <PriceRowPriceWithCaption
            size="S"
            caption="From"
            price={priceFrom.total}
            saleUnit="person"
          />
          <PriceRowCaption>Twin share</PriceRowCaption>

          {!header && priceFrom.discountPills?.discountPercentage && <PriceRowValueDiscount
            type="estimate"
            discountPercentage={priceFrom.discountPills.discountPercentage}
          />}
        </div>}
      </Group>

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          This offer has sold out
        </BodyText>
      </Group>}
    </>
  )
}

export default CruisePriceRoomTypeInfo
